export default __webpack_public_path__ + "static/media/bg-test.e2667658.jpg";